// hooks/useOutsideClick.js
import { useEffect } from 'react';

/**
 * Escucha clicks/pointer-downs fuera de `ref.current`.
 * Si menuIsClosed es true, dispara onOutsideClick en cualquier click/pointerdown.
 * @param {React.RefObject} ref
 * @param {Function}        onOutsideClick
 * @param {boolean}         enabled
 * @param {boolean}         menuIsClosed
 */
export default function useOutsideClick(ref, onOutsideClick, enabled = true, menuIsClosed = false) {
  useEffect(() => {
    if (!enabled) return;

    const handlePointerDown = (e) => {
      if (menuIsClosed) {
        onOutsideClick?.();
        return;
      }
      const el = ref?.current;
      if (el && !el.contains(e.target)) {
        onOutsideClick?.();
      }
    };

    document.addEventListener('pointerdown', handlePointerDown);
    return () =>
      document.removeEventListener('pointerdown', handlePointerDown);
  }, [ref, onOutsideClick, enabled, menuIsClosed]);
}
